export function findStartBlockIds(scripts = [], predicate = null) {
  if (!Array.isArray(scripts)) return [];
  return scripts
    .filter((block) => block && block.category === "start" && (typeof predicate === "function" ? predicate(block) : true))
    .map((block) => block.id)
    .filter(Boolean);
}

export function findStartBlocksByName(scripts = [], name) {
  return findStartBlockIds(scripts, (block) => block?.name === name);
}

export function findStartBlocksByType(scripts = [], type) {
  return findStartBlockIds(scripts, (block) => block?.type === type);
}

